import React, { useState } from "react";

import dayjs from "dayjs";
import { Formik, Form } from "formik";
import { useParams } from "react-router-dom";

import referenceSourceValuesApi from "apis/reference_source_values";
import { Pane, Typography, Button } from "clearsense-ui/components";
import { Input, Textarea, DatePicker } from "clearsense-ui/components/formik";

import {
  CREATE_VALUE_INITIAL_VALUES,
  CREATE_VALUE_VALIDATION_SCHEMA,
} from "../../../constants/valueReferenceSource";

const CreateValues = ({
  isCreateValuesOpen,
  setIsCreateValuesOpen,
  fetchReferenceSourceValuesData,
  isEdit,
  setIsEdit,
  rowToBeEdited,
  setRowToBeEdited,
  fetchReferenceSourceData,
}) => {
  const [isSaveAndAdd, setIsSaveAndAdd] = useState(false);
  const { referenceSourceId } = useParams();
  const initialValues = !isEdit
    ? CREATE_VALUE_INITIAL_VALUES
    : {
        name: rowToBeEdited.name,
        description: rowToBeEdited.description,
        startDate: rowToBeEdited.start_date,
        endDate: rowToBeEdited.end_date,
      };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      values: {
        name: values.name,
        description: values.description,
        start_date: dayjs(values.startDate).format("YYYY-MM-DD"),
        end_date: dayjs(values.endDate).format("YYYY-MM-DD"),
      },
    };
    try {
      {
        isEdit
          ? await referenceSourceValuesApi.update(rowToBeEdited?.id, payload)
          : await referenceSourceValuesApi.create(payload, referenceSourceId);
      }

      fetchReferenceSourceValuesData();
      fetchReferenceSourceData();
    } catch (error) {
      logger.log(error);
    } finally {
      setIsEdit(false);
      setRowToBeEdited({});
      if (isSaveAndAdd) {
        resetForm();
      } else setIsCreateValuesOpen(false);
    }
  };

  return (
    <Pane
      isOpen={isCreateValuesOpen}
      onClose={() => setIsCreateValuesOpen(false)}
      size="md"
      data-testid="create-pane"
    >
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          {isEdit
            ? "Edit Reference Source Value"
            : "Create Reference Source Value"}
        </Typography>
        {!isEdit && (
          <Typography style="large">
            Add a new value to a reference source
          </Typography>
        )}
      </Pane.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={CREATE_VALUE_VALIDATION_SCHEMA}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        <Form>
          <Pane.Body>
            <div className="py-8 flex w-full flex-col gap-4 overflow-auto">
              <Input
                name="name"
                label="Name"
                placeholder="Name"
                required
                data-cy="create-values-name-field"
              />
              <Textarea
                name="description"
                label="Description"
                placeholder="Description"
                data-cy="create-values-description-text-area"
              />
              <DatePicker
                name="startDate"
                dateFormat="MM-DD-YYYY"
                label="Start Date"
                placeholder="MM-DD-YYYY"
                data-cy="create-values-start-date"
              />
              <DatePicker
                name="endDate"
                dateFormat="MM-DD-YYYY"
                label="End Date"
                placeholder="MM-DD-YYYY"
                data-cy="create-values-end-date"
              />
            </div>
          </Pane.Body>
          <Pane.Footer className="gap-4">
            {!isEdit && (
              <Button
                label="Save and Add Another"
                type="submit"
                onClick={() => setIsSaveAndAdd(true)}
                data-cy="create-values-save-and-add-another"
                data-testid="save-add-button"
              />
            )}
            <Button
              label="Save and Close"
              type="submit"
              onClick={() => setIsSaveAndAdd(false)}
              data-cy="create-values-save-and-close-another"
              data-testid="save-close-button"
            />
            <Button
              label="Cancel"
              style="text"
              onClick={() => setIsCreateValuesOpen(false)}
              data-cy="create-values-cancel"
              data-testid="cancel-button"
            />
          </Pane.Footer>
        </Form>
      </Formik>
    </Pane>
  );
};

export default CreateValues;
